import { useNavigate } from 'react-router-dom';
import { LoginForm } from '../components/auth/LoginForm';

export function LoginPage() {
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 768;

  return (
    <LoginForm onSuccess={(role) => {
      if (role === 'monitoring') {
        navigate('/monitoring');
      } else if (role === 'operator') {
        navigate('/scan');
      } else if (role === 'accountant') {
        navigate('/dashboard');
      } else if (isMobile) {
        navigate('/scan');
      } else {
        navigate('/dashboard');
      }
    }} />
  );
}
